// extracted by mini-css-extract-plugin
module.exports = {"dataChart":"AllCharts_dataChart__3YgH7","chartInnerCard":"AllCharts_chartInnerCard__1j0DW"};